// src/project/data/triggers/updateWithdrawalAccount.js
import { buildActionUrl } from '../config/apiConfig'

export default {
  postUrl(payload = {}) {
    return buildActionUrl(`/accounts/update/${payload.id}?service=rapidoo`)
  },
  async format(payload = {}) {
    const cleanPhone = payload.phoneNumber ? String(payload.phoneNumber).replace(/\s+/g, '') : undefined
    return {
      accountLabel: payload.accountLabel || payload.owner,
      accountIsPhone: true,
      accountNumber: cleanPhone,
      wallet: payload.wallet,
    }
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Erreur lors de la mise à jour du compte',
        data: null,
      }
    }
    return {
      statusCode: 200,
      message: raw?.message || 'Compte mis à jour',
      data: raw?.data || {},
    }
  },
}
